import { PaletteOptions } from '@mui/material';

const merkurPalette: PaletteOptions = {
  primary: {
    25: '#FFFEF5',
    50: '#FFFCE8',
    100: '#FFF7CC',
    200: '#FFF1A3',
    300: '#FFE97A',
    400: '#FFDE52',
    500: '#F8D233',
    600: '#F8C515',
    700: '#D8A700',
    800: '#AD8500',
    900: '#7A5D00',
    main: '#F8C515',
    contrastText: '#102782',
  },
  secondary: {
    25: '#EAF0FF',
    50: '#D8E4FF',
    100: '#B7CBFF',
    200: '#96B2FF',
    300: '#7498FF',
    400: '#5582F4',
    500: '#3A69DF',
    600: '#2B52C8',
    700: '#1539B8',
    800: '#0D2B94',
    900: '#0A1E73',
    main: '#1539B8',
    contrastText: '#fff',
  },
  error: {
    25: '#FEF0F0',
    50: '#FEE2E2',
    100: '#FED4D4',
    200: '#FEC6C6',
    300: '#FDB2B2',
    400: '#FB8C8C',
    500: '#FA6565',
    600: '#F93F3F',
    700: '#8C1D18',
    800: '#601410',
    900: '#410E0B',
    main: '#FA6565',
  },
  neutral: {
    25: '#F5F8FF',
    50: '#EAF0FF',
    100: '#D4DEFF',
    200: '#B0C0F7',
    300: '#8EA4E8',
    400: '#6A82CC',
    500: '#4E67AE',
    600: '#354D94',
    700: '#22397C',
    800: '#162A66',
    900: '#0C1A4A',
    A100: '#FFFFFF1A',
  },
  info: {
    100: '#D8EEFF',
    300: '#A8D7FF',
    400: '#8CC9FF',
    500: '#6AB7FF',
    600: '#4DA8FF',
    700: '#2F7FC7',
    800: '#21588B',
    main: '#4DA8FF',
  },
  background: {
    default: '#081D79',
    paper: '#0D2B94',
  },
  text: {
    primary: '#fff',
    secondary: '#C5D3FF',
    disabled: '#7F94DB',
  },
  promoPage: {
    heading: '#FFFFFF',
    description: '#96B2FF',
    duration: '#D8E4FF',
    cardBackground: '#0D2B94',
    buttonBorder: '#0A1E73',
    buttonBackground: '#1539B8',
    buttonBackgroundHover: '#0D2B94',
    separator: '#3A69DF73',
  },
  gradient: '#F8C515',
  divider: '#254ABF',
} as const;

export default merkurPalette;
